/* global $ */
/* global WaveSurfer */
/* global StickySidebar */
/* global anime */
/* global peaks */
/* global filename */
/* global clamp */
/* global $clamp */
/* global nowave */
/*eslint no-console: ["error", { allow: ["warn", "error","log"] }] */
// Create an instance

var formatTime = function (time) {
  return [
    Math.floor((time % 3600) / 60), // minutes
    ('00' + Math.floor(time % 60)).slice(-2) // seconds
  ].join(':');
};

function confirmClick(message) {
    var agree = confirm(message);
    if (agree)
        return true;
    else
        return false;
}

var wavesurfer = {};
var ctx = document.createElement('canvas').getContext('2d');
var linGrad = ctx.createLinearGradient(0, 60, 0, 270);
linGrad.addColorStop(0.5, 'rgba(255, 255, 255, .7)');
linGrad.addColorStop(0.5, 'rgba(255, 255, 255, .33)');
// Init & load audio file

//Fix music player controls on scroll

window.onscroll = function() {myFunction()};
var header = document.getElementById("controls-wrapper");
var sticky = header.offsetTop;

function myFunction() {
  if (window.pageYOffset > sticky) {
    header.classList.add("sticky");

  } else {
    header.classList.remove("sticky");
  }
}

$(function() {
//window.onload = function() {
    //create random background image
    //var images = ['bg_43.jpg', 'bg_default.jpg'];
    //$('body').css({'background-image': 'url(img/artwork/' + images[Math.floor(Math.random() * images.length)] + ')'});

if (nowave == 0) {
    var pluginOptions = {
        height: 30,
        barWidth: 1,
        normalise: true,
        container: '#minimap',
      //  deferInit:true
    };

    wavesurfer = WaveSurfer.create({
      container: '#waveform',
      backend: 'MediaElement',
      responsive: true,
      mediaType:'audio',
      waveColor: linGrad,
      progressColor: '#fff',
      height: 160,
      normalise: true,
      barWidth: 3,
      plugins: [WaveSurfer.minimap.create(pluginOptions)]
    });

    // Load audio from URL
    wavesurfer.load('/samples/'+filename+'.mp3',peaks,'none');
    $('.waveform__duration').text( formatTime(wavesurfer.getDuration()));
    $('.waveform__counter').text( formatTime(wavesurfer.getCurrentTime()));
    // Play button
    //var button = document.querySelector('[data-action="play"]');
    //button.addEventListener('click', wavesurfer.playPause.bind(wavesurfer));

    var playPause = document.querySelector('[data-action="play"]');
       playPause.addEventListener('click', function() {
           wavesurfer.playPause();
       });

wavesurfer.on('audioprocess', function () {
  $('.waveform__counter').text( formatTime(wavesurfer.getCurrentTime()) );
});

    wavesurfer.on('ready', function() {
     wavesurfer.fireEvent('waveform-ready');
     wavesurfer.play();
     $('.waveform__duration').text( formatTime(wavesurfer.getDuration()) );
     $('.waveform__counter').text("0:00");
     console.log('fired');
   });

    wavesurfer.on('play', function () {
      $('.waveform__duration').text( formatTime(wavesurfer.getDuration()) );
      var item = $('.status-btn').data('position-marker');
      $('.pause-btn-tr').css('display','none');
      $('.play-btn-tr').css('display','block');
      $('*[data-position="'+item+'"] .play-btn-tr').css('display','none');
      $('*[data-position="'+item+'"] .pause-btn-tr').css('display','block');
      $('.play-btn').css('display','none');
      $('.pause-btn').css('display','block');
    });

    wavesurfer.on('pause', function () {
      $('.pause-btn-tr').css('display','none');
      $('.play-btn-tr').css('display','block');
      $('.pause-btn').css('display','none');
      $('.play-btn').css('display','block');
    });

      wavesurfer.on('finish', function () {
        var next = $('#forward-btn').data('position-marker');
        if (next > 0) {

          if (next > $('#forward-btn').data('max')) next = 1;

          if (next <= $('#forward-btn').data('max')) {
            //alert(next);
            var item = $('*[data-position="'+next+'"]');

            $('#forward-btn').data('position-marker',next+1);
            $('.rewind-btn').data('position-marker',next-1);
            $('.status-btn').data('position-marker',next);

            var tid = $(item).data('id');
            var file = $(item).data('file');
            var artist = $(item).data('artist');
            var track = $(item).data('track');

            $.ajax({method: 'post',
                    url:'/_includes/load-waveform.php?id='+$(item).data('id')}).done(function (data) {

              $('.play-btn').css('display','block');
              $('.pause-btn').css('display','none');
              $('.pause-btn-tr').css('display','none');
              $('.play-btn-tr').css('display','block');

              var peaks = JSON.parse("[" + data + "]");
              wavesurfer.load('/samples/'+file+'.mp3',peaks, 'none');
              $('.title-artist').html(artist);
              $('.title-track').html(track);
              $('.open-modal-track').data('title',artist+" - "+track);
              $('.open-modal-track').data('id',tid);
            });
          }
      }
});
}

    // Fix featured releases side bar if main content is longer
    var stickySidebar = new StickySidebar('#sidebar', {
      containerSelector: '.main_container',
      innerWrapperSelector: '.sidebar__inner'
    });

$('.forward-btn').css('cursor','pointer');
var linked = document.getElementById("forward-btn");
linked.addEventListener('click', function(e) {

//$('body').on('click','.forward-btn',function(e){
  e.stopPropagation();
  e.preventDefault();
  //wavesurfer.pause();
  var next = $(this).data('position-marker');
  if (next > 0) {
    if (next <= $(this).data('max')) {
      //alert(next);
      var item = $('*[data-position="'+next+'"]');

      $(this).data('position-marker',next+1);
      $('.rewind-btn').data('position-marker',next-1);
      $('.status-btn').data('position-marker',next);

      var tid = $(item).data('id');
      var file = $(item).data('file');
      var artist = $(item).data('artist');
      var track = $(item).data('track');

      $('.open-modal-track').data('id',tid);
      $('.open-modal-track').data('title',artist+" - "+track);

      $.ajax({method: 'post',
              url:'/_includes/load-waveform.php?id='+$(item).data('id')}).done(function (data) {

        $('.play-btn').css('display','block');
        $('.pause-btn').css('display','none');
        $('.pause-btn-tr').css('display','none');
        $('.play-btn-tr').css('display','block');

        var peaks = JSON.parse("[" + data + "]");
        wavesurfer.load('/samples/'+file+'.mp3',peaks, 'none');
        $('.title-artist').html(artist);
        $('.title-track').html(track);

      });


    }
  }
});

$('.rewind-btn').css('cursor','pointer');

var rewind = document.getElementById("rewind-btn");
rewind.addEventListener('click', function(e) {

//$('body').on('click','.rewind-btn',function(e){
  e.stopPropagation();
  e.preventDefault();
  var next = $(this).data('position-marker');

  if (next > 0) {

    var item = $('*[data-position="'+next+'"]');
    $(this).data('position-marker',next-1);
    $('.forward-btn').data('position-marker',next+1);
    $('.status-btn').data('position-marker',next);

    //wavesurfer.destroy();
    var tid = $(item).data('id');
    var file = $(item).data('file');
    var artist = $(item).data('artist');
    var track = $(item).data('track');

    $.ajax({method: 'post',
            url:'/_includes/load-waveform.php?id='+$(item).data('id')}).done(function (data) {
      //console.log(data);
      //wavesurfer.destroy();

      $('.play-btn').css('display','block');
      $('.pause-btn').css('display','none');
      $('.pause-btn-tr').css('display','none');
      $('.play-btn-tr').css('display','block');

      //wavesurfer.load('/samples/'+file+'.mp3',data, 'none');
      var peaks = JSON.parse("[" + data + "]");
      wavesurfer.load('/samples/'+file+'.mp3',peaks, 'none');
      $('.title-artist').html(artist);
      $('.title-track').html(track);
      $('.open-modal-track').data('id',tid);
      $('.open-modal-track').data('title',artist+" - "+track);

    });

  }
});


$('.play-track').css('cursor','pointer');
    $('body').on('click','.play-track',function(e){
      e.stopPropagation();
      e.preventDefault();
      var pos = $(this).data('position');
      var status = wavesurfer.isPlaying();
      var playing = $('.status-btn').data('position-marker');
      //$('.rewind-btn').data('position-marker',pos-1);
      //$('.forward-btn').data('position-marker',pos+1);
      //$('.status-btn').data('position-marker',pos);
      var tid = $(this).data('id');
      var file = $(this).data('file');
      var artist = $(this).data('artist');
      var track = $(this).data('track');

      //alert(wavesurfer.isPlaying());
      if (status == true && pos == playing) { // playing and same track clicked - Pause it!
        //alert('playing and same track clicked - Pause it!');
        wavesurfer.pause();
        $('*[data-position="'+pos+'"] .play-btn-tr').css('display','none');
        $('*[data-position="'+pos+'"] .pause-btn-tr').css('display','block');
        $('.play-btn').css('display','none');
        $('.open-modal-track').data('id',tid);
        $('.open-modal-track').data('title',artist+" - "+track);
        $('.pause-btn').css('display','block');
      } else if (status == false && pos == playing) { // playing but different track clicked.
        wavesurfer.play();
        $('*[data-position="'+pos+'"] .pause-btn-tr').css('display','none');
        $('*[data-position="'+pos+'"] .play-btn-tr').css('display','block');
        $('.open-modal-track').data('id',tid);
        $('.open-modal-track').data('title',artist+" - "+track);
        $('.pause-btn').css('display','none');
        $('.play-btn').css('display','block');
      } else if (status == true && pos != playing) { // playing but different track clicked.
        //alert('playing but different track clicked.');
        $('.open-modal-track').data('id',tid);
        $('.open-modal-track').data('title',artist+" - "+track);
        $('.rewind-btn').data('position-marker',pos-1);
        $('.forward-btn').data('position-marker',pos+1);
        $('.status-btn').data('position-marker',pos);

      $.ajax({method: 'post',
              url:'/_includes/load-waveform.php?id='+$(this).data('id')}).done(function (data) {



              $('.pause-btn-tr').css('display','none');
              $('.play-btn-tr').css('display','block');

        var peaks = JSON.parse("[" + data + "]");
        wavesurfer.load('/samples/'+file+'.mp3',peaks, 'none');
        $('.title-artist').html(artist);
        $('.title-track').html(track);
        $('.open-modal-track').data('id',tid);
        $('.open-modal-track').data('title',artist+" - "+track);


        });

      } else {

        $('.open-modal-track').data('id',tid);
        $('.rewind-btn').data('position-marker',pos-1);
        $('.forward-btn').data('position-marker',pos+1);
        $('.status-btn').data('position-marker',pos);

      $.ajax({method: 'post',
              url:'/_includes/load-waveform.php?id='+$(this).data('id')}).done(function (data) {

        var peaks = JSON.parse("[" + data + "]");
        wavesurfer.load('/samples/'+file+'.mp3',peaks, 'none');
        $('.title-artist').html(artist);
        $('.title-track').html(track);
        $('.open-modal-track').data('id',tid);

        $('.pause-btn-tr').css('display','none');
        $('.play-btn-tr').css('display','block');

        });
 }
    });

    $('.btn-download-options').css('cursor','pointer');
    $('body').on('click','.btn-download-options',function(e){
      e.stopPropagation();
      e.preventDefault();
     if ($(this).parent().hasClass('open')){
          $(this).parent().removeClass('open');
      }else{
          $('.btn-extend').removeClass('open');
          $(this).parent().addClass('open');
      }
    });

$('.formats a').css('cursor','pointer');
$('.formats a').css('cursor','pointer');
    $('body').on('click','.formats a',function(e){
          $(this).parent().parent().parent().removeClass('open');
    });

$('.btn-instr').css('cursor','pointer');
    $('body').on('click','.btn-instr',function(e){
      e.stopPropagation();
      e.preventDefault();

      var row = $(this).closest('.track-options-row');
      if($(row).hasClass('open')){
        $(row).removeClass('open');
      }else{
        $('.track-options-row').removeClass('open');
        $(row).addClass('open');
      }

    });
    //Remove btn extension (.open) if click anywhere outside .btn-extend
    $(document).mouseup(function(e)
    {
        var container = $(".btn-extend");

        // if the target of the click isn't the container nor a descendant of the container
        if (!container.is(e.target) && container.has(e.target).length === 0)
        {
            container.removeClass('open')
        }
    });


  var timeline = anime.timeline();
  timeline
    .add({
      targets: '.background-image-container',
      opacity: .4,
      //delay: 1000,
      duration: 2000,
      easing: 'easeInExpo'
    })
    .add({
      targets: '.sampler-details-wrapper',
      translateY: [-50,0],
    //  delay: 0,
      opacity: 1,
      offset: '-=2000',
      duration: 500,
      easing: 'easeOutExpo'
    })
    .add({
      targets: '.wave-title-wrapper',
      translateY: [-50,0],
      opacity: 1,
      offset: '-=500',
      easing: 'easeOutExpo'
    })
    .add({
      targets: '.waveform-container',
      translateY: [50,0],
      opacity: 1,
      offset: '-=500',
      easing: 'easeOutExpo'
    })
    .add({
      targets: '.controls',
      translateX: [-200,0],
      opacity: 1,
      offset: '-=500',
    //  delay: 0,
      easing: 'easeOutExpo'
    })
    .add({
      targets: '.search-box-pos',
      translateY: [50,0],
      opacity: 1,
      offset: '-=500',
    //  delay: 0,
      easing: 'easeOutExpo'
    })
    .add({
      targets: '.tracklists-wrapper',
      opacity: 1,
    //  delay: 0,
      translateY: [50,0],
      easing: 'easeOutExpo',
      complete: function(anim) {
        $('body').css({'overflow':'auto', 'height':'auto', 'position':'relative'});
      }
    })
    .add({
      targets: '.counter-wrapper',
      translateY: [-200,0],
      opacity: 1,
      offset: '-=500',
    //  delay: 0,
      easing: 'easeOutExpo'
    });

//}
  //modal stuff
    $('body').on('click','.open-modal',function(e){
      e.stopPropagation();
      e.preventDefault();
      $('.download-title').html("<b>"+$(this).data('title')+"</b>");
      $(".btn-mp3").attr('formaction', '/download/mp3-320'+$(this).data('type')+'/'+$(this).data('file')+'/'+$(this).data('key'));
      $(".btn-wav").attr('formaction', '/download/wav'+$(this).data('type')+'/'+$(this).data('file')+'/'+$(this).data('key'));
      $('body').addClass('open-modal');
    });

    $('body').on('click','.open-modal-track',function(e){
      e.stopPropagation();
      e.preventDefault();
      $('.download-title').html("<b>"+$(this).data('title')+"</b>");
      $(".btn-mp3").attr('href', '/download-file/mp3-320/'+$(this).data('id')+'/'+$(this).data('key'));
      $(".btn-wav").attr('href', '/download-file/wav/'+$(this).data('id')+'/'+$(this).data('key'));
      //$(".btn-mp3").attr('formaction', '/download/mp3-320'+$(this).data('type')+'/'+$(this).data('file')+'/'+$(this).data('key'));
      //$(".btn-wav").attr('formaction', '/download/wav'+$(this).data('type')+'/'+$(this).data('file')+'/'+$(this).data('key'));
      $('body').addClass('open-modal-track');
    });

    $('body').on('click','#close-modal',function(e){
      e.stopPropagation();
      e.preventDefault();
      $('body').removeClass('open-modal');
      $('body').removeClass('open-modal-track');
      $(".btn-mp3").attr('href', '');
      $(".btn-wav").attr('href', '');
      $('.download-title').html('');
    });

    $('body').on('click','.btn-zipper',function(e){
      $('body').removeClass('open-modal');
    });

    $('.clamp').each(function(index,element) {
    //  alert(element);
    //  $(element).css('color', 'red');
      $clamp(element, { clamp: 2});
    });
});



// WEBPACK FOOTER //
// src/js/main.js